import { render, staticRenderFns } from "./sensorCard.vue?vue&type=template&id=7123f4b6&scoped=true"
import script from "./sensorCard.vue?vue&type=script&lang=js"
export * from "./sensorCard.vue?vue&type=script&lang=js"
import style0 from "./sensorCard.vue?vue&type=style&index=0&id=7123f4b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7123f4b6",
  null
  
)

export default component.exports